import React from "react";
import { connect } from 'react-redux'
import { Row, Col, CardHeader, Card, CardTitle, CardBody, Table, Button } from "reactstrap";
import { studentActions } from '../actions';
import { CenterMessageCard } from 'components/CenterMessageCard';


import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';

var Icons = require ('Icons');
var Utils = require ('Utils');
var viewActions = require ('store/view.actions');
var studentService = require ('../api');

 

class StudentCalif extends React.Component {

  componentDidMount() { 
    this.props.getCourseEvaluations(this.props.token, this.props.studentCourseID); 
    this.props.getMyEvaluations(this.props.token,  this.props.currentCalendarID) ;
    this.props.setMainTitle("Boletín de calificaciones", [] )
  }

  constructor(props) {
    super(props);
    this.state = {
      isDownloading: false,
      hasObjectives: false      // ver de ponerlo cuando haya objetivos cargados
    }

 }


 // Descarga de boletin
 downloadCalifReport( extra ) {
  viewActions.notification({message:'El documento ya se esta generando, luego de unos segundos iniciará la descarga.',
              title:'Descarga',type:'success'});
  
  studentService.getMyEvaluationReport ( this.props.token,  this.props.currentCalendarID, extra )
          .then( json => {
            const {vfs} = vfsFonts.pdfMake;
            pdfMake.vfs = vfs;
            const documentDefinition = {
              pageSize: 'A4',
              pageOrientation: 'portrait',
              pageMargins: [40, 70, 40, 60],

              header: json.pageHeader,
              content: [
                json.studentHeader,
                json.logbook,
                json.attendance,
                json.signatures,
                json.footerNotes
          
              ],
              footer: json.pageFooter,
              styles: json.styles
            } ;
            pdfMake.createPdf(documentDefinition).open();
        } )
}


  render() {
     return (
     (
      ( Utils.getParam(this.props.sysParams, 'BOLETIN_'+this.props.topLevel)!=='Y'  )?
      
      <CenterMessageCard 
          icon="fa-hand-paper-o"
          title="Oooops 🧐">
            La descarga de boletines no esta disponible en este momento. 
      </CenterMessageCard> 
      :
      <>
        <div className="content">
          <Card>
               
              <CardHeader>
                <CardTitle>
                 
                  <div className="float-right">
                    {(!this.props.view.loadingModules.getMyEvaluations  )&&
                       <>
                        <Button color="success" size="sm" 
                              disabled={this.state.isDownloading}
                              onClick={() => this.downloadCalifReport( 0 )}
                            >
                              <>
                                <i className={Icons.DOWNLOAD} /> 
                                Boletín
                              </>
                          </Button>
                           <Button color="success" size="sm" 
                           disabled={this.state.isDownloading}
                           onClick={() => this.downloadCalifReport( 1 )}
                         >
                           <>
                             <i className={Icons.DOWNLOAD} /> 
                             Boletín Extraprogramático
                           </>
                       </Button>
                       </>
                     }
                  </div> <h4>Calificaciones</h4>
                </CardTitle>
              </CardHeader>
              <CardBody> 
                <Row>
                  <Col sm="12">
                    <Table responsive bordered striped size="sm">
                      <thead>
                        <tr>
                          <th width="20%">Materia</th>
                          {this.state.hasObjectives && <th width="30%">Objetivos</th> }

                          { this.props.courseEvaluations.map( (ev) => {
                              return <th width="10%">{ev.short_name}</th>
                            }
                          )
                          }

                          
                          <th width="70%">Observaciones</th>
                        </tr>
                      </thead>
                      <tbody>
                      {this.props.myEvaluations.map( (subject) => {
                            return (
                                <tr>
                                  <td> {subject.long_name} </td>
                                  { this.state.hasObjectives && <td> {subject.objectives} </td> }
                                  
                                  { this.props.courseEvaluations.map( (trime) => {
                                    let ev = subject.evaluations.find( eva =>  eva.evaluation_id === trime.evaluation_id) ;
                                                        
                                    return (
                                             (ev?
                                                  <td align="center"> 
                                                    <span style={{color: ev.color}}>
                                                      {ev.short_name?ev.short_name:<b>{ev.qualif_value_nbr}</b>}
                                                    </span>
                                                  </td> 
                                                  :
                                                  <td align="center">-</td>
                                                  )
                                                )
                                              }
                                            )
                                  }
                                  
                                  <td>
                                  { subject.evaluations.length>0 ? subject.evaluations.map( ( ev, idx ) => {
                                    return (
                                      ev.comments &&
                                        <> 
                                        {(idx>0?<br/>:"")} 
                                        <span style={{color: ev.color}}>
                                          {ev.eval_short_name}: {ev.comments}
                                        </span>
                                        </>
                                    )
                                  }):

                                  <></>
                                  }
                                  </td>

                                </tr>
                          )
                        } )
                        }
                      </tbody>

                    </Table>
                  </Col>
                </Row>
                
                
                
                </CardBody>
          </Card>
         </div>
      </>
    )
    );
  }
}

 const mapStateToProps = state => {
    return {
        studentCourseID: state.auth.session.student_course_id,
        sysParams: state.auth.sysParams,
        token: state.auth.session.jwt_token,
        currentCalendarID:  state.school.currentCalendarID,
        view: state.view,
        topLevel: state.auth.session.student_top_level,
        user: state.auth.session.user,
        myEvaluations: state.students.myEvaluations,
        courseEvaluations: state.students.courseEvaluations
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getMyEvaluations: ( token, calendarID ) => {
          dispatch(studentActions.getMyEvaluations( token, calendarID  ));
        },
        getCourseEvaluations: ( token,  studentCourseID)  => {
          dispatch(studentActions.getCourseEvaluations( token, studentCourseID  ));
        },




        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu))
        },
        
      
 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(StudentCalif);

